import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryUsers(
  {
    page, size, direction, sort, nickname, grade, telephone,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/shop-users`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
      nickname,
      grade,
      telephone,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryUser(userId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/shop-users/${userId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  nickname
 * @param  openId
 * @param  avatar
 * @param  remark
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addUser(
  {
    nickname,
    openId,
    avatar,
    remark,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/shop-users`,
    method: 'post',
    data: {
      nickname,
      openId,
      avatar,
      remark,
    },
  });
}

/**
 *
  导出user excel 表格；
 */
export function _exportUserExcel({
  nickname,
  telephone,
  grade,
  sort,
  direction,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/shop-users-export`,
    method: 'get',
    params: {
      nickname,
      telephone,
      grade,
      sort,
      direction
    },
  });
}
/**
 * 更新
 * @param userId
 * @param  nickname
 * @param  openId
 * @param  avatar
 * @param  remark
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateUser(userId, {
  nickname,
  openId,
  avatar,
  remark,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/shop-users/${userId}`,
    method: 'patch',
    data: {
      nickname,
      openId,
      avatar,
      remark,
    },
  });
}

/**
 * 更新
 * @param userId
 * @param  nickname
 * @param  openId
 * @param  avatar
 * @param  remark
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateUserPoints(userId, {
  changePoints,
  remark,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/shop-users/${userId}/points`,
    method: 'patch',
    data: {
      changePoints,
      remark,
    },
  });
}

/**
 * 删除
 * @param userId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteUser(userId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/shop-users/${userId}`,
    method: 'delete',
  });
}

export function _updateUserGrade(userId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/shop-users/${userId}/grade`,
    method: 'get',
  });
}
export default {};
